import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import API from '../api/axios';

export default function SubscriptionCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Verifying payment...');

  useEffect(() => {
    const status = searchParams.get('status');
    const txRef = searchParams.get('tx_ref');

    if (status === 'cancelled') {
      setMessage('Payment cancelled.');
      setTimeout(() => navigate('/premium'), 2000);
      return;
    }

    if (status === 'successful' && txRef) {
      // Verify with backend which verifies with Flutterwave
      API.post('/api/billing/verify', { tx_ref: txRef })
        .then(() => {
          setMessage('Payment confirmed! Activating your subscription...');
          setTimeout(() => navigate('/likes'), 3000);
        })
        .catch(() => {
          setMessage('Payment verification failed. Contact support.');
          setTimeout(() => navigate('/premium'), 3000);
        });
    } else {
      setMessage('Payment failed. Please try again.');
      setTimeout(() => navigate('/premium'), 2000);
    }
  }, [navigate, searchParams]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: '16px'
    }}>
      <p style={{ fontSize: '18px' }}>{message}</p>
    </div>
  );
}